import { render, staticRenderFns } from "./PrimeSelectPicUpload.vue?vue&type=template&id=39bee288&scoped=true&"
import script from "./PrimeSelectPicUpload.vue?vue&type=script&lang=js&"
export * from "./PrimeSelectPicUpload.vue?vue&type=script&lang=js&"
import style0 from "./PrimeSelectPicUpload.vue?vue&type=style&index=0&id=39bee288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bee288",
  null
  
)

export default component.exports